import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import _ from 'lodash';
import { MdBookmarkOutline, MdInfoOutline, MdPersonOutline, MdPerson } from 'react-icons/lib/md';
import Modal from 'react-modal';
import  ReactTooltip from 'react-tooltip';
import { modalStyle } from '../../constants';
import { milestoneToTitle, statusFromDates, formatDate, formatPhoneNumber, formatEmail} from '../../utils/';
import { getMILESTONES } from '../detail/schedule_constants';
import { getDateValue } from '../../utils/date';
import { isActiveEmployee } from '../../utils/team';
import { setAELookAEServProjId } from '../../actions/additional_actions';
import PhaseChart from '../detail/phaseChart';
import { setCurrentTabIndex } from '../../actions/additional_actions';

const projectKey = (projectId) => (string) => {
  return `${projectId}-${string}`;
}

const DateTable = ({ keyFunc, divisionName, schedule }) => {
  let currentBaseline = null;

  if (_.some(schedule, 'constructionBaseline')) {
    currentBaseline = 'constructionBaseline';
  } else if (_.some(schedule, 'designBaseline')) {
    currentBaseline = 'designBaseline';
  }

  return (
    <table className="date-table">
      <thead>
        <tr>
          <th>Milestone</th>
          <th>Current Baseline</th>
          <th>Projected / Actual</th>
          <th>CEB</th>
          <th>On time</th>
        </tr>
      </thead>
      <tbody>
      { getMILESTONES(divisionName).map((key) => {
        const row = schedule[key];
        if (row !== null) {         
        return (
          <tr key={keyFunc('-dt-' + key)}>
            <td>{milestoneToTitle(key, divisionName)}</td>
            <td className="dt-green">
               <span>{ formatDate(row[currentBaseline])  }</span> 
            </td>
            <td className={row.actual ? 'dt-red' : 'dt-blue'}>
              <span>{ formatDate(row.actual || row.projected) }</span>
              <strong>{row.actual ? 'ACTUAL' : 'PROJECTED'}</strong>
            </td>
            <td className="dt-green"> {key === 'designCompletion' || key === 'constructionCompletion'
              ? <span>{ formatDate(row.clientExtendedBaseline) }</span> : null} </td>
            <td className="dt-status">
              { statusFromDates(row.projected, row.actual) }
            </td>
          </tr>
        );
      }
      else return null;
      })}
      </tbody>
    </table>
  );
}

DateTable.propTypes = {
  keyFunc: PropTypes.func.isRequired,
  divisionName: PropTypes.string.isRequired,
  schedule: PropTypes.object.isRequired,
}

class ProjectCard extends Component {

  constructor (props) {
    super(props);

    this.showModal = this.showModal.bind(this);
    this.onDone = this.onDone.bind(this);
    this.getDateForDisplay = this.getDateForDisplay.bind();

    this.state = {
      redirect: false,
      modalVisible: false,
    }
  }

  onDone() {
    this.setState({modalVisible: false});
  }

  showModal(e) {
    e.stopPropagation();
    this.setState ({modalVisible: true});
  }

  renderMembers (members) {
    return members.slice(0, 3).map(({ member, projectTitle }) => {
      const key = `${member.id}-${projectTitle.id}`;
      const fullName = member.firstName + ' ' + member.lastName;
      return (
        <div key={key} className="col s12">
          <h6>{projectTitle.title}</h6>
            <span>
              {
                isActiveEmployee(member) && <MdPerson className='user-icon active-user' data-for='user-icon' data-tip="In DDC"/>
              }
              {
                isActiveEmployee(member) === false && <MdPersonOutline className='user-icon inactive-user' data-for='user-icon' data-tip="Not in DDC"/>
              }
              {
                isActiveEmployee(member) === null && <MdPersonOutline className='user-icon' data-for='user-icon' data-tip="Status Unknown"/>
              }
              {fullName}
            </span>
          
          {formatEmail(member.email)}
          {formatPhoneNumber(member.telExtension)}
          <ReactTooltip id='user-icon'/>
        </div>
      );
    });
  }
  
  redirectToProjecttab(projectId) {
    this.props.setCurrentTabIndex(0);
    this.setState({redirect: true, projectId: projectId});
  }

  getDateForDisplay(date) {
    if (!date) return 'N/A';

    if (Object.prototype.toString.call(date) === '[object String]') {
        date = new Date(date);
    }

    let dateString = (date.getMonth() + 1)+ '/' + date.getDate() + '/' + date.getFullYear();
    return dateString;
}

  render () {
    const { project, pmReqAEServProjId } = this.props;
    const members = project.projectTeams;
    const keyFunc = projectKey(project.projectId);
    const lastApprovedOn = project.projectInfoApprovalDate;

    if (pmReqAEServProjId === project.projectId) {
      this.props.dispatch(setAELookAEServProjId(pmReqAEServProjId));
    }

    if (this.state.redirect) {
      const path = `/projects/${project.projectId}`;
      return <Redirect push={true} to={path} />;
    }

    return (
      <div>
        <div className="card">
          <div className="card-left" 
             onClick={() => this.redirectToProjecttab(project.projectid)}>
          <div className="categories">
            {project.divisionName} / {project.projectType}
          </div>
          <h4>
            {project.projectId}
            <span className="separator"/>
            {project.projectDescription}
          </h4>
          <p><strong>Current Phase:</strong> {project.phase}</p>
          <p><strong>Subphase:</strong> {project.subPhase}</p>
          <p className="fmsids">
            <strong>FMS ID:</strong>{' '}
            {project.fmsids !== null && project.fmsids.length > 0 ? project.fmsids.map(f => f !== null ? f.fmsid : null).join(', ') : null}
          </p>
          <p><strong>Review Approval Date:</strong>{this.getDateForDisplay(lastApprovedOn)}</p>
          {(project.contractProcModelList && project.contractProcModelList.length > 0) ?
          <p className="hover-blue" onClick={this.showModal}>
            <strong>
              <MdInfoOutline size={18} color='#294FA6' className="align-top margin-right-0325" />
              CSB Status for construction:</strong>
              {project.contractProcModelList[0].procurementStatus}
            </p>
            : null }

          <div className="row card-details">
            { members!==null ? this.renderMembers(members) : null}
          </div>
        </div>

        <div className="card-right">
          <DateTable
            keyFunc={keyFunc}
            divisionName={project.divisionName}
            schedule={project.schedule}
          />
        </div>

         <div className="inside-card-div">
              <span className="dot"></span><p className="circle-p">completed</p>
              <span className="dot" id="yellow-circle"></span><p className="circle-p">current</p>
              <span className="dot" id="blue-circle"></span><p className="circle-p">future</p>
            </div> 

         <PhaseChart project={project}/>  

        <button
          className={'watchlist-' + (project.inWatchlist ? 'remove' : 'add')}
          onClick={this.props.onChangeWatch}
        >
        <span><MdBookmarkOutline className = "fa-Icon-Watchlist"/></span>
        </button>
      </div>

        {this.state.modalVisible
          ? <Modal
            isOpen={this.state.modalVisible}
            style={modalStyle}
            contentLabel="Contracts"
          >
            <div>
              <h1>Contracts</h1>

               <div className="modal-form">

                <div className="row margin-bottom-075">
                  <div className="col l4 s4">
                    <strong>Pin # </strong>
                  </div>
                  <div className="col l8 s8 margin-top-0">
                    <p className="margin-top-0">
                    { project.contractProcModelList.length > 0 ? project.contractProcModelList[0].pinNumber : null}
                    </p>
                  </div>
                </div>

                <div className="row margin-bottom-075">
                  <div className="col l4 s4">
                    <strong>Reg # </strong>
                  </div>
                  <div className="col l8 s8 margin-top-0">
                   <p className="margin-top-0">
                   { project.contractProcModelList.length > 0 ? project.contractProcModelList[0].regNumber : null}
                     </p>
                  </div>
                </div>

                <div className="row margin-bottom-075">
                  <div className="col l4 s4">
                    <strong>Contract Type: </strong>
                  </div>
                  <div className="col l8 s8 margin-top-0">
                  <p className="margin-top-0">
                  { project.contractProcModelList.length > 0 ? project.contractProcModelList[0].contractType : null}
                    </p>
                  </div>
                </div>

                {project.contractProcModelList.length > 0 && project.contractProcModelList[0].contractor !== null
                  ? <div className="row margin-bottom-075">
                    <div className="col l4 s4">
                      <strong>Vendor:</strong>
                    </div>
                    <div className="col l8 s8 margin-top-0">
                      <p className="margin-top-0">
                        {project.contractProcModelList[0].contractor}
                      </p>
                    </div>
                  </div>
                  : null}

                {project.contractProcModelList.length > 0 && project.contractProcModelList[0].bidAmount !== null 
                  ? <div className="row margin-bottom-075">
                    <div className="col l4 s4">
                      <strong>Bid Amount:</strong>
                    </div>
                    <div className="col l8 s8 margin-top-0">
                      <p className="margin-top-0">
                        {project.contractProcModelList[0].bidAmount}
                      </p>
                    </div>
                  </div>
                  : null}

            {project.contractProcModelList.length > 0 && project.contractProcModelList[0].procurementStatus !== null 
             ?  <div className="row margin-bottom-075">
                  <div className="col l4 s4">
                    <strong>{project.contractProcModelList[0].procurementStatus}:</strong>
                  </div>
                  <div className="col l8 s8 display-linebreak margin-top-0">
                  <p className="margin-top-0">
                      { 
                      (project.contractProcModelList[0].procurementStatus==='Schedule Bid Avertisement' || 
                      project.contractProcModelList[0].procurementStatus==='Schedule Bid Avertisment') ? 
                        `Sch. Start - Sch. End: ${getDateValue(project.contractProcModelList[0].schedBidSchedStart)} - ${getDateValue(project.contractProcModelList[0].schedBidSchedEnd)}\\n\\n Act. Start - Act. End: ${getDateValue(project.contractProcModelList[0].schedBidActualStart)} - ${getDateValue(project.contractProcModelList[0].schedBidActualEnd)}` 
                        : null
                    }
                    { 
                      (project.contractProcModelList[0].procurementStatus==='In Advertising') ? 
                        `Sch. Start - Sch. End: ${getDateValue(project.contractProcModelList[0].inAdvertisingSchedStart)} - ${getDateValue(project.contractProcModelList[0].inAdvertisingSchedEnd)}\\n\\n Act. Start - Act. End: ${getDateValue(project.contractProcModelList[0].inAdvertisingActualStart)} - ${getDateValue(project.contractProcModelList[0].inAdvertisingActualEnd)}` 
                        : null
                    }
                    { 
                      (project.contractProcModelList[0].procurementStatus==='Bid Dates') ? 
                        `Sch. Start - Sch. End: ${getDateValue(project.contractProcModelList[0].bidDatesSchedStart)} - ${getDateValue(project.contractProcModelList[0].bidDatesSchedEnd)}\\n\\n Act. Start - Act. End: ${getDateValue(project.contractProcModelList[0].bidDatesActualStart)} - ${getDateValue(project.contractProcModelList[0].bidDatesActualEnd)}` 
                        : null
                    }
                    { 
                      (project.contractProcModelList[0].procurementStatus==='Pre Award / APT') ? 
                        `Sch. Start - Sch. End: ${getDateValue(project.contractProcModelList[0].preAwardSchedStart)} - ${getDateValue(project.contractProcModelList[0].preAwardSchedEnd)}\\n\\n Act. Start - Act. End: ${getDateValue(project.contractProcModelList[0].preAwardActualStart)} - ${getDateValue(project.contractProcModelList[0].preAwardActualEnd)}` 
                        : null
                    }
                    { 
                      (project.contractProcModelList[0].procurementStatus==='Award') ? 
                        `Sch. Start - Sch. End: ${getDateValue(project.contractProcModelList[0].awardSchedStart)} - ${getDateValue(project.contractProcModelList[0].awardSchedEnd)}\\n\\n Act. Start - Act. End: ${getDateValue(project.contractProcModelList[0].awardActualStart)} - ${getDateValue(project.contractProcModelList[0].awardActualEnd)}` 
                        : null
                    }
                    { 
                      (project.contractProcModelList[0].procurementStatus==='Execution') ? 
                        `Sch. Start - Sch. End: ${getDateValue(project.contractProcModelList[0].executionSchedStart)} - ${getDateValue(project.contractProcModelList[0].executionSchedEnd)}\\n\\n Act. Start - Act. End: ${getDateValue(project.contractProcModelList[0].executionActualStart)} - ${getDateValue(project.contractProcModelList[0].executionActualEnd)}` 
                        : null
                    }
                    { 
                      (project.contractProcModelList[0].procurementStatus==='Registration') ? 
                        `Sch. Start - Sch. End: ${getDateValue(project.contractProcModelList[0].registrationSchedStart)} - ${getDateValue(project.contractProcModelList[0].registrationSchedEnd)}\\n\\nAct. Start - Act. End: ${getDateValue(project.contractProcModelList[0].registrationActualStart)} - ${getDateValue(project.contractProcModelList[0].registrationActualEnd)}` 
                        : null
                    }
                    </p>
                  </div>
                </div>
                : null }

              </div> 

              <div className="modal-close" onClick={this.onDone}>
                <span className="close"></span>
              </div>

            </div>
          </Modal>
          : null}

      </div>
    )
  }
}

ProjectCard.propTypes = {
  project: PropTypes.object.isRequired,
  onChangeWatch: PropTypes.func.isRequired
};

function mapStateToProps(state, ownProps) {
  return {}
}

export default connect(mapStateToProps, {setCurrentTabIndex} )(ProjectCard);